/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_No_Members_Yet_Description_AdminInputs */



/**
* | output |
* | --- |
* | "Use the Add Member option to invite new members to your organization." |
*
* @param {Members_No_Members_Yet_Description_AdminInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_no_members_yet_description_admin = /** @type {((inputs?: Members_No_Members_Yet_Description_AdminInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_No_Members_Yet_Description_AdminInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwende die Option 'Mitglied hinzufügen', um neue Mitglieder zu deiner Organisation einzuladen.")
	return /** @type {LocalizedString} */ ("Use the Add Member option to invite new members to your organization.")
});